import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import firebase from "./firebase";

Vue.config.productionTip = false;
let app = null;

firebase.auth().onAuthStateChanged(() => {
    if (!app) {
        app = new Vue({
            router,
            store,
            vuetify,
            render: h => h(App)
        }).$mount("#app");
    }
});

// new Vue({
//     router,
//     store,
//     vuetify,
//     render: h => h(App)
// }).$mount('#app');